export const Configs = {
    gmap_apikey: 'AIzaSyBs0qijxdixLNNwCx2cW8fZmaEZRPnZIvg'
}
